import { CheckboxField } from "src/components/FormikComponents/CheckboxField";

interface IDefinitionIncludeSplitsProps {
  initialValue: boolean;
  value: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
}

export const DefinitionIncludeSplits = (props: IDefinitionIncludeSplitsProps): JSX.Element => {
  const { initialValue, value, onChange, disabled } = props;
  const isDirty = initialValue !== value;

  return (
    <CheckboxField
      className={`includesplits_control ${isDirty ? "dirty" : ""}`}
      label="Include Splits"
      value={value}
      onChange={() => onChange(!value)}
      meta={{
        initialValue: initialValue,
        touched: isDirty,
      }}
      disabled={disabled}
    />
  );
};
